import AuditUnitCondition from "./AuditUnitCondition"
import { WizardPictureStep } from "../../ui/wizard"
import AuditUnitConfirm from "./AuditUnitConfirm"
import { compressImage, getExtensionFromMimeType } from '../../../utilities/imageUtilities'
import AuditUnitAddPhoto from "./AuditUnitAddPhoto"
import AuditUnitConditionReport from "./AuditUnitConditionReport"

export default function AuditUnitSteps({
  auditUnit,
  auditData,
  setAuditData,
  setIsEditing,
  auditUnitFiles,
  isConditionReport = false,
  requiredPhotos = []
}) {
  const handleImageSubmit = async (title, image) => {
    if (image) {
      const compressedImage = await compressImage(image)
      const renamedFile = new File([compressedImage], `${title}${getExtensionFromMimeType(compressedImage.type)}`, { type: compressedImage.type })
      setAuditData((previous) => {
        return {
          ...previous,
          images: {
            ...previous.images,
            [title]: renamedFile
          }
        }
      })
    }
  }

  const isRequiredPhoto = (title) => requiredPhotos.includes(title)

  // Condition reports always need their full photo set, even when the unit was not touched
  const isSkippingRequiredPhotos = auditData.condition === '4' && !isConditionReport

  const pictureEntries = Object.entries(auditData.images).filter(([title]) => !(isSkippingRequiredPhotos && isRequiredPhoto(title)))

  const photoTitles = pictureEntries.map(([title]) => title)

  return [
    {
      Component: AuditUnitCondition,
      props: {
        auditUnit: auditUnit,
        auditData: auditData,
        setAuditData: setAuditData
      }
    },
    ...(isConditionReport ? [{
      Component: AuditUnitConditionReport,
      props: {
        auditUnit: auditUnit,
        auditData: auditData,
        setAuditData: setAuditData
      }
    }] : []),
    ...pictureEntries.map(([title, image]) => ({
      Component: WizardPictureStep,
      props: {
        title: title,
        handleSubmit: async (image) => await handleImageSubmit(title, image),
        previewable: true,
        includeUploadPhotoButton: !isRequiredPhoto(title),
        image: image ?? auditUnitFiles?.find((file) => file.attributes.name === title)?.attributes.url
      }
    })),
    {
      Component: AuditUnitAddPhoto,
      props: {
        photoTitles: photoTitles,
        setAuditData: setAuditData
      }
    },
    {
      Component: AuditUnitConfirm,
      props: {
        auditUnit: auditUnit,
        auditData: auditData,
        setAuditData: setAuditData,
        setIsEditing: setIsEditing,
        auditUnitFiles: auditUnitFiles,
        photoTitles: photoTitles,
        isConditionReport: isConditionReport
      }
    }
  ]
}
